import { render, staticRenderFns } from "./HerstellerKundenumsaetzeTabelle.vue?vue&type=template&id=9f3b4c64&scoped=true&"
import script from "./HerstellerKundenumsaetzeTabelle.vue?vue&type=script&lang=js&"
export * from "./HerstellerKundenumsaetzeTabelle.vue?vue&type=script&lang=js&"
import style0 from "./HerstellerKundenumsaetzeTabelle.vue?vue&type=style&index=0&id=9f3b4c64&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f3b4c64",
  null
  
)

export default component.exports